import * as React from 'react';
import ReactDom from 'react-dom';
import {omit, merge, set, get} from 'lodash';

import {useWithDataSource} from '@forms/Utils/Hooks';
import {send} from '@forms/Utils';
import Client from './Client';
import DEFAULT_PROPS from './Client/defaultProps';
import {UniversityFieldTripsRFQFormData} from './Client/definitions';

const searchToValues = () => {
	try {
		const destination = (new URLSearchParams(window.location.search)).get('destination');

		if (destination) {
			return set({}, 'quoteRequest.destination', destination);
		}
	} catch(e) {}

	return {};
};

// Props, injected by dataset.
type UniversityFieldTripRFQForm = {
	component: string;
	csrfToken: string;
	labelUri: string;
	nodeAggregateIdentifier: string;
	redirectUri: string;
	rfqUri: string;
	captchaIsActive: string;
	captchaSitekey: string;
}
export default ($el: HTMLElement) => {
	const $node = $el.querySelector('[data-select="UniversityFieldTripsRfqForm"]');

	if (!$node) {
		return null;
	}

	// Get injected config by dataset.
	const CONFIG = {...$el.dataset} as UniversityFieldTripRFQForm;
	const $disclaimer = $el.querySelector('[data-select="disclaimer"]') as HTMLElement;

	// Get default + injected props
	const defaultValues = merge({},
		DEFAULT_PROPS,
		searchToValues()
	);

	const thanks = () => window.location.href = CONFIG.redirectUri;

	// Form API
	const submit = (data: UniversityFieldTripsRFQFormData) => {
		send({
			uri: CONFIG.rfqUri,
			csrfToken: CONFIG.csrfToken,
			node: CONFIG.nodeAggregateIdentifier,
			data: {
				...omit(data, ['hidden']),
			},
			onSuccess: thanks,
			onFail: () => {}
		})
	}

	const withLabel = () => useWithDataSource({
		uri: CONFIG.labelUri
	});

	ReactDom.render(
		<Client {...{submit, withLabel, $disclaimer}}
			defaultValues={defaultValues}
			captchaIsActive={CONFIG.captchaIsActive === '1'}
			captchaSitekey={CONFIG.captchaSitekey}
		/>,
		$node
	);
}
